import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * AgencyZoom Get Customer v1 Configuration Validator
 * Validates AgencyZoom customer retrieval configuration
 * Requires either phone or email (but at least one must be provided)
 */
export const Agencyzoom_Get_Customer_1_ConfigValidator = z
    .object({
    connection: requiredString('AgencyZoom Connection is required'),
    phone: z.string().optional(),
    email: z.string().email('Invalid email format').optional()
})
    .refine((data) => data.phone || data.email, {
    message: 'Either phone or email must be provided',
    path: ['phone']
});
//# sourceMappingURL=agencyzoom-get-customer-1.js.map